export default __webpack_public_path__ + "static/media/3.cbab2c35.jpg";